import { render, staticRenderFns } from "./PhysicalExam.vue?vue&type=template&id=55b687b8&scoped=true"
import script from "./PhysicalExam.vue?vue&type=script&lang=js"
export * from "./PhysicalExam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b687b8",
  null
  
)

export default component.exports